import * as React from 'react';
import FormView from '../../FormView';
import { withRouter } from 'react-router';
import { INotePadProperties } from '../interfaces';

class NotePad extends React.PureComponent<INotePadProperties> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/purchase-order-enquiry/notepad':
          onInitialLoad('Notepad');
          break;
        default:
          onInitialLoad('OrderDetails');
      }
    }
  }

  getInitialValues = () => {
    const {
      selectedOrder
    } = this.props;
    const params = (new URLSearchParams(location.search));
    const purchaseOrder = params.get('PurchaseOrder') || '';

    return {
      params: {
        PurchaseOrder: (selectedOrder && selectedOrder.PurchaseOrder) || purchaseOrder,
      }
    };

  };

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={this.getInitialValues()}
          operationMode={operationMode}
          enableReinitialize={true}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(NotePad);
